import { DEFAULT_COLOR } from 'MeetingsBase/constants/colors';
const defaults = {
  companyName: null,
  logoAltText: null,
  logoHeight: null,
  logoUrl: null,
  logoWidth: null,
  primaryColor: DEFAULT_COLOR
};

// TODO: Remove in Phase 6 after downstream repos migrate to createBranding()
class BrandingCompat {
  constructor(json) {
    return createBranding(json);
  }
  static from(json) {
    return createBranding(json);
  }
}
export default BrandingCompat;
export function createBranding(json) {
  if (json) {
    var _json$logoAltText, _json$logoHeight, _json$logoWidth, _json$companyName;
    const logoUrl = 'logoUrl' in json ? json.logoUrl : json.companyLogo;
    const primaryColor = 'primaryColor' in json ? json.primaryColor : json.accentColor;
    return {
      primaryColor: primaryColor || DEFAULT_COLOR,
      logoUrl: logoUrl !== null && logoUrl !== void 0 ? logoUrl : null,
      logoAltText: (_json$logoAltText = json.logoAltText) !== null && _json$logoAltText !== void 0 ? _json$logoAltText : null,
      logoHeight: (_json$logoHeight = json.logoHeight) !== null && _json$logoHeight !== void 0 ? _json$logoHeight : null,
      logoWidth: (_json$logoWidth = json.logoWidth) !== null && _json$logoWidth !== void 0 ? _json$logoWidth : null,
      companyName: (_json$companyName = json.companyName) !== null && _json$companyName !== void 0 ? _json$companyName : null
    };
  }
  return Object.assign({}, defaults);
}